import request from '../utils/request'

export function companyPage(params) {
  return request({
    url: '/company/page',
    method: 'GET',
    params: params
  })
}


export function companyCreate(params) {
  return request({
    url: '/company/create',
    method: 'POST',
    params: params
  })
}

export function companyUpdate(params) {
  return request({
    url: '/company/update/' + params.id,
    method: 'PATCH',
    params: params
  })
}

export function companyDelete(data) {
  return request({
    url: '/company/delete',
    method: 'DELETE',
    data
  })
}

export function companyStatus (status, data) {
  return request({
    url: '/company/' + status,
    method: 'put',
    data
  })
}


export function companyGetMemberEquityQuota(params) {
  return request({
    url: '/company/getMemberEquityQuota',
    method: 'get',
    params
  })
}


export function companyUpdateMemberEquityQuota (data) {
  return request({
    url: '/company/updateMemberEquityQuota',
    method: 'post',
    data
  })
}

export function companyDeleteMemberEquityQuota (params) {
  return request({
    url: '/company/deleteMemberEquityQuota',
    method: 'post',
    params
  })
}

